const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'Type ',
        dataIndex: 'withdrawType',
        sorter: true,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        sorter: true,
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
    {
        title: 'Requested Date',
        dataIndex: 'requestDate',
        sorter: true,
    },
];

export default columns;